export const VISITATION_TYPE_TEMPLATE = {
  INITIAL_EVALUATION: 1,
  IMPLANTATION: 2,
  INTERCURRENCE: 3,
  TELESERVICE_ATTENDANT: 4,
  TELESERVICE_PROFESSIONAL: 5
};
